if (!customElements.get('stil-detail')) {
  customElements.define(
    'stil-detail',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const choose = event.target.closest('[data-stil-choose]');
          if (choose) {
            const sizes = choose.parentElement.querySelector('.stil-detail__sizes');
            if (sizes) sizes.hidden = false;
            return;
          }

          const size = event.target.closest('[data-stil-size]');
          if (size && !size.disabled) {
            this.addVariant(size.dataset.variantId, size);
            return;
          }

          const add = event.target.closest('[data-stil-add]');
          if (add && !add.disabled) this.addVariant(add.dataset.variantId, add);
        });
      }

      addVariant(id, button) {
        if (!id || button.getAttribute('aria-disabled') === 'true') return;
        button.setAttribute('aria-disabled', 'true');

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        const body = { items: [{ id: Number(id), quantity: 1 }] };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement?.(document.activeElement);
        }
        config.body = JSON.stringify(body);

        const cartAddUrl =
          (typeof routes !== 'undefined' && routes.cart_add_url) || window.routes?.cart_add_url || '/cart/add';

        fetch(cartAddUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) return;
            if (!cart) {
              window.location = window.routes?.cart_url || '/cart';
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'stil-detail', cartData: response });
            }
            if (typeof cart.renderContents === 'function') cart.renderContents(response);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            button.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
